// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';

import {
  ImportDetailRowsResultDto,
  ScritturaPreconsolidamentoDto,
} from '@ideapa/common-dto';
import { SelectItem } from '@ideapa/common-interfaces';
import { Observable, map } from 'rxjs';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class ScritturaPreconsolidamentoApiClient extends BaseCRUDApiClient<ScritturaPreconsolidamentoDto> {
  baseUrl = this.config.apiEndpoint + '/scrittura-preconsolidamento';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  getSoggetti() {
    return this.http.post<SelectItem[]>(`${this.baseUrl}/soggetti`, {});
  }

  downloadPdfPreconsolidamento(
    fileName: string,
    idSoggetto?: string
  ): Observable<ArrayBuffer> {
    return this.http
      .post(
        this.baseUrl + '/download-pdf-preconsolidamento',
        {
          idSoggetto: idSoggetto,
          fileName: fileName,
        },
        {
          responseType: 'arraybuffer',
        }
      )
      .pipe(
        map((file: ArrayBuffer) => {
          return file;
        })
      );
  }

  cancellazioneScritturePreconsolidamento() {
    this._pagedCache.clear();
    return this.http.get(`${this.baseUrl}/cancella-scritture`);
  }

  importExcelFile(file: File) {
    this._pagedCache.clear();
    const fd = new FormData();
    fd.append('file', file);
    return this.http.post<ImportDetailRowsResultDto>(
      this.baseUrl + '/import-excel',
      fd
    );
  }
}
